import React from "react";
import Link from "next/link";
import Head from "next/head";
import { useTranslation } from "next-i18next";

type Props = {
    title: React.ReactNode;
    img: string,
    imgAlt: string,
    imgMobile?: string,
    preloadImg?: boolean,
    className?: string
};

const PlatformHeroSection: React.FC<Props> = ({ title, img, imgAlt, imgMobile, preloadImg, className }) => {
    const { t } = useTranslation("common");
    return (
        <>
            {preloadImg && (
                <Head>
                    <link rel="preload" as="image" href={img} fetchPriority="high" />
                </Head>
            )}
            <section className={`hero-section ${className}`}>
                <div className={'container'}>
                    {title}
                    <div className={"d-flex"}>
                        <Link href={"https://app.middleware.io/auth/register/"} target={"_blank"}
                              className={"sign-up ahref-btn primary"}>{t('cta.getStarted')}</Link>
                        <Link href={"/demo-request/"} className={"sign-up ahref-btn secondary"}>{t('cta.bookDemo')}</Link>
                    </div>
                    {imgMobile ? (
                        <picture>
                            <source media="(max-width: 768px)" srcSet={imgMobile} />
                            <img src={img} alt={imgAlt} width={100} height={100} fetchPriority="high" loading="eager" decoding="async" />
                        </picture>
                    ) : (
                        <img src={img} alt={imgAlt} width={100} height={100} fetchPriority="high" loading="eager" decoding="async" />
                    )}
                </div>
            </section>
        </>
    )
}

export default PlatformHeroSection;